// extracted by mini-css-extract-plugin
export var bottomAligned = "FormHeader-module__bottomAligned___WD8J+";
export var columnWrapper = "FormHeader-module__columnWrapper___6TQOo";
export var fieldsRequiredNote = "FormHeader-module__fieldsRequiredNote___Y8MxF";
export var formHeader = "FormHeader-module__formHeader___YAk3L";
export var formHeaderSubFormContent = "FormHeader-module__formHeaderSubFormContent___p6v8B";
export var formStepsGroup = "FormHeader-module__formStepsGroup___flOJP";
export var large = "1084px";
export var mainFormTitle = "FormHeader-module__mainFormTitle___SWPBH";
export var medium = "860px";
export var small = "540px";
export var subtitle = "FormHeader-module__subtitle___SA6J-";
export var title = "FormHeader-module__title___dTLy8";